import { Injectable } from '@angular/core';
import { AbstractFeatureAclService } from '@y42/feature/acl';
import { Y42FeatureType } from '@y42/json-schema';
import { VisualizationWidgetQuery } from '../../state/widget';

@Injectable({ providedIn: 'root' })
export class VisualizationWidgetAclService extends AbstractFeatureAclService {
  constructor(query: VisualizationWidgetQuery) {
    super({
      featureType: Y42FeatureType.VisualizationWidget,
      query,
    });
  }
}
